export const getImageDimensions = async (imageUrl: string) => {
  const img = new Image()
  img.src = imageUrl

  try {
    await img.decode()
    const imgWidth = img.naturalWidth
    const imgHeight = img.naturalHeight

    return {
      imgWidth,
      imgHeight,
    }
  } catch (err) {
    return {
      imgWidth: 0,
      imgHeight: 0,
    }
  }
}

export const checkIfImageHasBadResolution = async (imageUrl: string) => {
  const { imgWidth, imgHeight } = await getImageDimensions(imageUrl)

  return imgWidth < 800 || imgHeight < 800
}
